export enum DialerTypes {
  none = -1,
  cyclic = 0,
  unisson = 1,
  sequential = 2,
  oldestidle = 3,
}
